import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircleIcon, ChevronDownIcon, PhoneIcon, MailIcon, MapPinIcon, SendIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input, Textarea } from '../../components/ui/Input';
const FAQ_ITEMS = [{
  q: 'Làm thế nào để nạp tiền vào ví?',
  a: 'Đăng nhập vào tài khoản, vào mục "Ví MHP", chọn số tiền muốn nạp (bội số 10.000.000đ) và xác nhận. Bạn sẽ nhận ngay +2.5% tín dụng thưởng.'
}, {
  q: 'Tín dụng ví có thời hạn bao lâu?',
  a: 'Tín dụng ví có hiệu lực 12 tháng kể từ giao dịch gần nhất. Bạn sẽ nhận thông báo trước khi tín dụng hết hạn.'
}, {
  q: 'Làm sao để nâng hạng thành viên?',
  a: 'Hạng thành viên tự động nâng cấp dựa trên điểm tích lũy: Bạc (1.000 điểm), Vàng (5.000 điểm), VIP (15.000 điểm). Mỗi 100.000đ chi tiêu = 1 điểm.'
}, {
  q: 'Tôi có thể chuyển tín dụng cho người khác không?',
  a: 'Tín dụng ví không thể chuyển nhượng cho người khác. Tín dụng chỉ có thể sử dụng bởi chủ tài khoản.'
}, {
  q: 'Làm thế nào để đổi điểm thưởng?',
  a: 'Vào mục "Phần Thưởng", chọn phần thưởng bạn muốn đổi và xác nhận. 1.000 điểm = 500.000đ tín dụng mua hàng. Điểm sẽ được trừ ngay lập tức.'
}, {
  q: 'Tôi quên mật khẩu/không nhận được OTP?',
  a: 'Vui lòng liên hệ hotline 1900 xxxx hoặc đến trực tiếp cửa hàng Mỹ Hòa Phát gần nhất để được hỗ trợ.'
}];
export function SupportPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [contactName, setContactName] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [contactMessage, setContactMessage] = useState('');
  const [sent, setSent] = useState(false);
  const handleSubmit = () => {
    setSent(true);
    setContactName('');
    setContactPhone('');
    setContactMessage('');
    setTimeout(() => setSent(false), 3000);
  };
  return <div className="max-w-4xl mx-auto px-4 py-8" data-id="element-1626">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-1627">
        <h1 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-1628">
          <HelpCircleIcon className="w-7 h-7 text-[#C8A84E]" data-id="element-1629" />
          Hỗ Trợ
        </h1>
      </motion.div>

      {/* FAQ */}
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.05
    }} data-id="element-1630">
        <Card title="Câu Hỏi Thường Gặp" className="mb-6" data-id="element-1631">
          <div className="space-y-1" data-id="element-1632">
            {FAQ_ITEMS.map((item, i) => <div key={i} className="border-b border-[#2A2A2A]/50 last:border-0" data-id="element-1633">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between py-3 text-left" data-id="element-1634">
                  <span className="text-sm font-medium text-white pr-4" data-id="element-1635">
                    {item.q}
                  </span>
                  <ChevronDownIcon className={`w-4 h-4 text-[#666666] flex-shrink-0 transition-transform duration-200 ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-1636" />
                </button>
                <AnimatePresence data-id="element-1637">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} className="overflow-hidden" data-id="element-1638">
                      <p className="text-sm text-[#B0B0B0] pb-3" data-id="element-1639">{item.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </Card>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1640">
        {/* Contact Info */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} data-id="element-1641">
          <Card title="Liên Hệ" className="h-full" data-id="element-1642">
            <div className="space-y-4" data-id="element-1643">
              <div className="flex items-center gap-3" data-id="element-1644">
                <div className="w-10 h-10 bg-[#C8A84E]/10 rounded-lg flex items-center justify-center" data-id="element-1645">
                  <PhoneIcon className="w-5 h-5 text-[#C8A84E]" data-id="element-1646" />
                </div>
                <div data-id="element-1647">
                  <p className="text-sm font-medium text-white" data-id="element-1648">Hotline</p>
                  <p className="text-sm text-[#B0B0B0]" data-id="element-1649">1900 xxxx</p>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-1650">
                <div className="w-10 h-10 bg-[#C8A84E]/10 rounded-lg flex items-center justify-center" data-id="element-1651">
                  <MailIcon className="w-5 h-5 text-[#C8A84E]" data-id="element-1652" />
                </div>
                <div data-id="element-1653">
                  <p className="text-sm font-medium text-white" data-id="element-1654">Email</p>
                  <p className="text-sm text-[#B0B0B0]" data-id="element-1655">hotro@myhoaphat.com</p>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-1656">
                <div className="w-10 h-10 bg-[#C8A84E]/10 rounded-lg flex items-center justify-center" data-id="element-1657">
                  <MapPinIcon className="w-5 h-5 text-[#C8A84E]" data-id="element-1658" />
                </div>
                <div data-id="element-1659">
                  <p className="text-sm font-medium text-white" data-id="element-1660">Địa chỉ</p>
                  <p className="text-sm text-[#B0B0B0]" data-id="element-1661">
                    Hệ thống cửa hàng Mỹ Hòa Phát toàn quốc
                  </p>
                </div>
              </div>
            </div>
          </Card>
        </motion.div>

        {/* Contact Form */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15
      }} data-id="element-1662">
          <Card title="Gửi Yêu Cầu Hỗ Trợ" data-id="element-1663">
            {sent ? <div className="text-center py-6" data-id="element-1664">
                <div className="text-3xl mb-2" data-id="element-1665">✅</div>
                <p className="text-sm text-[#22C55E]" data-id="element-1666">
                  Đã gửi! Chúng tôi sẽ phản hồi sớm nhất.
                </p>
              </div> : <div className="space-y-3" data-id="element-1667">
                <Input label="Họ tên" value={contactName} onChange={e => setContactName(e.target.value)} placeholder="Nguyễn Văn A" data-id="element-1668" />
                <Input label="Số điện thoại" value={contactPhone} onChange={e => setContactPhone(e.target.value)} placeholder="0901 234 567" data-id="element-1669" />
                <Textarea label="Nội dung" value={contactMessage} onChange={e => setContactMessage(e.target.value)} placeholder="Mô tả vấn đề của bạn..." rows={4} data-id="element-1670" />
                <Button fullWidth onClick={handleSubmit} disabled={!contactMessage} data-id="element-1671">
                  <SendIcon className="w-4 h-4" data-id="element-1672" />
                  Gửi
                </Button>
              </div>}
          </Card>
        </motion.div>
      </div>
    </div>;
}